import { render, staticRenderFns } from "./ErrorLinksTab.vue?vue&type=template&id=67034afe&scoped=true"
import script from "./ErrorLinksTab.vue?vue&type=script&lang=js"
export * from "./ErrorLinksTab.vue?vue&type=script&lang=js"
import style0 from "./ErrorLinksTab.vue?vue&type=style&index=0&id=67034afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67034afe",
  null
  
)

export default component.exports